import { render, staticRenderFns } from "./OrderDiscountExpandableHeader.vue?vue&type=template&id=581d03cd&scoped=true&"
import script from "./OrderDiscountExpandableHeader.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountExpandableHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderDiscountExpandableHeader.vue?vue&type=style&index=0&id=581d03cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d03cd",
  null
  
)

export default component.exports